module.exports = __webpack_public_path__ + "img/providence.cef153b1.png";